import { useRequestContext } from 'components/pages/request/providers/request-provider'
import { useCollaboratorTicketContext } from 'components/pages/collaborator-ticket/collaborator-ticket-provider'
import { useIsCollaboratorView } from 'providers/is-collaborator-view-provider'

/**
 * A unified hook that provides access to the appropriate ticket context based on whether
 * the current view is a collaborator view or not.
 */
export function useAdaptiveRequestContext() {
  const isCollaboratorView = useIsCollaboratorView() ?? false
  const requestContext = useRequestContext()
  const collaboratorContext = useCollaboratorTicketContext()

  return isCollaboratorView ? collaboratorContext : requestContext
}
